import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "index"
};
const _hoisted_2 = {
  key: 0,
  class: "head"
};
const _hoisted_3 = {
  class: "head-btn"
};
const _hoisted_4 = {
  class: "item-left"
};
const _hoisted_5 = {
  class: "account"
};
const _hoisted_6 = {
  key: 0,
  class: "orderNo"
};
const _hoisted_7 = {
  class: "time"
};
const _hoisted_8 = {
  class: "item-right"
};
import CustomBar from "@/components/customBar";
import { ref, onMounted } from "vue";
import { redeemOutpage, redeemStats, redeemStockOrders } from "@/api/index";
import { debounce } from "@/utils/index";
import Empty from "@/components/empty";
import { usebaseRouter } from "@/utils/hooks";
export default {
  __name: 'index',
  setup(__props) {
    const {
      getQuery
    } = usebaseRouter();
    const stats = ref(1);
    const list = ref([]);
    const loading = ref(false);
    const finished = ref(false);
    const page = ref(1);
    const {
      type
    } = getQuery();
    const getRedeemStats = () => {
      redeemStats().then(res => {
        stats.value = res.outSum;
      });
    };
    //调接口获取数据
    const getlist = () => {
      const api = type == 1 ? redeemOutpage : redeemStockOrders;
      api({
        pageNo: page.value
      }).then(res => {
        list.value.push(...res.data);
        loading.value = false;
        if (page.value == 1 && res.data.length == 0 || page.value >= res.totalPage) {
          finished.value = true;
        }
      });
    };

    // 上拉加载
    const onLoad = debounce(() => {
      page.value += 1;
      getlist();
    });
    onMounted(() => {
      getlist();
      if (type == 1) {
        getRedeemStats();
      }
    });
    return (_ctx, _cache) => {
      const _component_van_list = _resolveComponent("van-list");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_unref(CustomBar), {
        title: `${_unref(type) == 1 ? '转让' : '出库'}记录`
      }, null, 8, ["title"]), _createElementVNode("div", _hoisted_1, [_unref(type) == 1 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, "总转让数：" + _toDisplayString(stats.value), 1)])) : _createCommentVNode("", true), _createVNode(_component_van_list, {
        class: "content",
        loading: loading.value,
        "onUpdate:loading": _cache[0] || (_cache[0] = $event => loading.value = $event),
        offset: 30,
        "immediate-check": false,
        finished: finished.value,
        "finished-text": "没有更多了",
        onLoad: _unref(onLoad)
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: "item",
            key: index
          }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, "账号：" + _toDisplayString(_unref(type) == 1 ? item.toAcct : item.mobile), 1), _unref(type) == 2 ? (_openBlock(), _createElementBlock("div", _hoisted_6, "订单号：" + _toDisplayString(item.orderNo), 1)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_7, _toDisplayString(item.createTime), 1)]), _createElementVNode("div", _hoisted_8, _toDisplayString(item.qty), 1)]);
        }), 128))]),
        _: 1
      }, 8, ["loading", "finished", "onLoad"]), list.value.length == 0 ? (_openBlock(), _createBlock(_unref(Empty), {
        key: 1,
        text: "暂无转让记录"
      })) : _createCommentVNode("", true)])], 64);
    };
  }
};